/**
 * className utility for conditional classes
 * Combines multiple class names, filtering out falsy values
 * 
 * Usage:
 * cn('base-class', condition && 'conditional-class', className)
 * cn('px-4', 'py-2', isActive && 'bg-primary', className)
 */
export function cn(...classes) {
  return classes.filter(Boolean).join(' ');
}
